import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  LOADER_TIMEOUT_TIME,
  SWAL_SETTINGS,
  showFilterlist,
  showFilterlistNew,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { List, Delete, Status } from "../../services/medicine.services";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const MedicineReportTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    // { title: t("sidebar_link_restaurant"), url: "" },
    { title: t("Medicine Management"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);


  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
            setLoader(false);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
    params.pgno = 1;
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    params.pgno = 1;
  };

  const headerMapping = {
    "medicine_id": "Medicine ID",
    "name": "Name",
    "medicine_used": "Medicine Usage",
  };

  const handleExport = () => {
    const formData = new FormData()
    formData.append("page", 1)
    formData.append("per_page", datalength)
    formData.append("sort", JSON.stringify({}))
    formData.append("search", JSON.stringify({}))
    formData.append("global_search", globalsearch)
    List(formData).then(data => {
      setDataLength(data.data.total_records);
      const listData = data && data.data && data.data.list ? data.data.list : [];
      const printData = listData.map((item) => {
        const transformedItem = {};
        const medicineRegisterID = item?.medicine_id ? '#' + (item?.medicine_id) : "-";
        const Name = item?.name || 'N/A';

        for (const key in headerMapping) {
          if (headerMapping.hasOwnProperty(key)) {
            const newKey = headerMapping[key];
            switch (key) {
              case "medicine_id":
                transformedItem[newKey] = (medicineRegisterID);
                break;
              case "name":
                transformedItem[newKey] = capitalizeFirstLetter(Name);
                break;
              case "medicine_used":
                transformedItem[newKey] = 'See separate sheet';
                break;
              default:
                console.warn(`Unexpected key in headerMapping: ${key}`);
                transformedItem[newKey] = 'N/A';
                break;
            }
          }
        }
        return transformedItem;
      });

      //   const patientData = listData.flatMap(item => {
      //     const Name = item?.name || 'N/A';
      //     return (item.medicine_usage_data || []).map(data => ({
      //         'Medicine Name': capitalizeFirstLetter(Name), 
      //         'Center Name': capitalizeFirstLetter(data?.center_name || 'N/A'),
      //         'Doctor Name': capitalizeFirstLetter(data?.doctor_name || 'N/A'),
      //         'Patient Name': capitalizeFirstLetter(data?.patient_name || 'N/A'),
      //         'Patient Email': (data?.patient_email || 'N/A'),
      //         'Patient Phone Number': (data?.patient_phone || 'N/A'),
      //     }));
      // });

      const patientData = listData.flatMap(item => {
        const Name = item?.name || 'N/A';
        return (item.medicine_usage_data || []).flatMap(data => {
          return (data.medicines || []).map(medicine => ({
            'Medicine Name': capitalizeFirstLetter(Name),
            'Center Name': capitalizeFirstLetter(data?.center_name || 'N/A'),
            'Doctor Name': capitalizeFirstLetter(data?.doctor_name || 'N/A'),
            'Patient Name': capitalizeFirstLetter(data?.patient_name || 'N/A'),
            'Patient Email': (data?.patient_email || 'N/A'),
            'Patient Phone Number': (data?.patient_phone || 'N/A'),
            'Medicine Dosage': medicine?.dosage || 'N/A',
          }));
        });
      });

      const ws1 = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
      const ws2 = XLSX.utils.json_to_sheet(patientData, { header: ['Medicine Name', 'Center Name', 'Doctor Name', 'Patient Name', 'Patient Email', 'Patient Phone Number', 'Medicine Dosage'] });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws1, 'Medicine List');
      XLSX.utils.book_append_sheet(wb, ws2, 'Medicine Usage');
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, 'medicine.xlsx');
      setTimeout(() => {
        setLoader(false);
      }, LOADER_TIMEOUT_TIME);
    }).catch(error => {
      setTimeout(() => {
        setLoader(false);
      }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    })
  };

  useEffect(() => {
    if (params.pgno && parseInt(params.pgno) !== 1) {
      navigate("/admin/report-management/medicine/list/1", { replace: true });
    }
  }, []);

  return (
    <>
      <div className="animation_fade">
        <div className="row">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {/* {t("Medicine Management")} */}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlistNew}
                    prepareSearch={prepareSearch}
                  />
                </div> */}
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("admin.filter_placeholder.btn_reset_filter")}
                </button>
                {/* <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/medicine-management/medicine/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button> */}
                <button className="btn ripple btn-main-primary signbtn mr-2" onClick={handleExport} disabled={datalength === 0}>Export Report</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Medicine ID")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="medicine_id"
                        />
                      </div>
                    </th>
                    <th>{t("Medicine Name")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr
                              key={i}
                            >
                              <td>{row?.medicine_id ? '#' + '' + (row?.medicine_id) : "-"}</td>
                              <td>
                                {row?.name ? (
                                  <div className="d-flex">
                                    {row?.name ? capitalizeFirstLetter(TrimText(row.name, 30)) : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("admin.message.msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Medicine Management",
                    path: "/admin/report-management/medicine/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

    </>
  );
};

export default MedicineReportTable;
